export const shapeOptions = [
	{ label: 'Circle', value: 'circle' },
	{ label: 'Flower', value: 'flower' },
	{ label: 'Sketch', value: 'sketch' },
	{ label: 'Triangle', value: 'triangle' },
	{ label: 'Blob', value: 'blob' },
	{ label: 'Hexagon', value: 'hexagon' },
	{ label: 'Custom', value: 'custom' }
];

export const sizeOptions = [
	{ label: 'Fit', value: 'contain' },
	{ label: 'Fill', value: 'cover' },
	{ label: 'Custom', value: 'custom' }
];

export const positionOptions = [
	{ label: 'Center Center', value: 'center center' },
	{ label: 'Center Left', value: 'center left' },
	{ label: 'Center Right', value: 'center right' },
	{ label: 'Top Center', value: 'top center' },
	{ label: 'Top Left', value: 'top left' },
	{ label: 'Top Right', value: 'top right' },
	{ label: 'Bottom Center', value: 'bottom center' },
	{ label: 'Bottom Left', value: 'bottom left' },
	{ label: 'Bottom Right', value: 'bottom right' },
	{ label: 'Custom', value: 'custom' }
];

export const repeatOptions = [
	{ label: 'No-repeat', value: 'no-repeat' },
	{ label: 'Repeat', value: 'repeat' },
	{ label: 'Repeat-x', value: 'repeat-x' },
	{ label: 'Repeat-y', value: 'repeat-y' },
	{ label: 'Round', value: 'round' },
	{ label: 'Space', value: 'space' }
];